import React from 'react'

import DownloadDriverForm from '../DownloadDriverForm'

const CaForm = () => {
  return (
    <>
       
             <DownloadDriverForm
        brand="CANON"
        image="https://support-printers.netlify.app/img/logo_01.png"
      />
    </>
  )
}

export default CaForm
